export const OTHER_CHAR_LIMIT = 65;
